<div class="position-absolute cursor-pointer pointer-events-auto z-1 w-logo h-logo d-flex align-items-center justify-content-center" style="left:0">
    <img  
        role="button"                                    
        [routerLink]="['landing']"
        [routerLinkActive]="'active'"        
        [src]="isDark() ? 'assets/images/logo.png' : 'assets/images/logo-light.png' " />
</div>

    
<div class="position-absolute cursor-pointer pointer-events-auto z-1 mt-3 me-2" style="right:0">

    <span>
        <span role="button" class="material-icons-sharp font-8 mt-1 primary-text-100 ms-3" style="opacity: 0.4; pointer-events: none; cursor: not-allowed;">notifications_none</span>                         
    </span>
    
    <span>        
        <span role="button" class="material-icons-sharp font-8 mt-1 primary-text-100 ms-3" style="opacity: 0.4; pointer-events: none; cursor: not-allowed;" id="theme-toggle" (click)="toggleTheme()">
            {{ isDark() ? 'brightness_2' : 'brightness_7' }}
        </span>
    </span>

    <current-user-header style="opacity: 0.4; pointer-events: none; cursor: not-allowed;" />
</div>


<div class="container-fluid w-100">

    @if (currentHeader(); as currentHeader)
    {
        <menu-layout position="top">                              
            <div class="d-flex justify-content-between align-items-center w-100 top-menu-container">
                <span class="padding-1 primary-gradient-bg-100 m-2 clip3 search-container">
                    <span class="search d-flex align-items-center search-bg clip3 h-100">
                        <div class="form-group h-100">
                            <input disabled type="text" class="form-control border-0 primary-text ps-5 px-3 py-2 h-100">
                        </div>
                        <span class="material-icons-sharp font-8 position-absolute ms-3 primary-text-100">search</span>
                    </span>
                </span>
                <div>
                    <presenter [data]="currentHeader" />               
                </div>           
            </div> 
        </menu-layout>
    }      
</div>   
